import Icon from "@material-ui/icons/Person";
import AcademicYearShow from "./CcaAcademicYearShow";
import AcademicYearCreate from "./CcaAcademicYearCreate";
import AcademicYearEdit from "./CcaAcademicYearEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "ccaAcademicYears",
  show: AcademicYearShow,
  edit: AcademicYearEdit,
  create: AcademicYearCreate,
  icon: Icon,
};
